import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';
import ProjectsDropdown from './ProjectsDropdown';
import MobileMenu from './MobileMenu';

function Navbar() {
  const [isHovered, setIsHovered] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" className="logo-link">
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>
        </div>
        <nav className="navbar-nav">
          <ul>
            <li><Link to="/">HOME</Link></li>
            <li><Link to="/team">OUR TEAM</Link></li>
            <li
              className="dropdown-wrapper"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Link to="/projects" className="projects-link">PROJECTS</Link>
              {isHovered && (
                <div className="dropdown-container">
                  <ProjectsDropdown />
                </div>
              )}
            </li>
            <li><Link to="/resources">RESOURCES</Link></li>
            <li><Link to="/contact">CONTACT</Link></li>
          </ul>
        </nav>
        <button
          className={`hamburger${mobileOpen ? ' hamburger--hidden' : ''}`}
          aria-label="Open menu"
          onClick={() => setMobileOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
        <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} />
      </div>
    </header>
  );
}

export default Navbar;
